import SearchStringUtil from '../../../../../utils/searchString.utils';
import { FilterByQueryParams } from '../types/offlineFilterOptionsRepository.utils.types';

export default class OfflineFilterOptionsRepositoryUtils {
  static filterByQuery<T>({ items, query, searchFields = [] }: FilterByQueryParams<T>): T[] {
    if (!query || !searchFields.length) {
      return items;
    }

    const terms = SearchStringUtil.prepareForSearch(query);
    if (!terms.length) {
      return items;
    }

    const filteredItems = items.filter((item) => this.filterItems(item, searchFields, terms));
    return filteredItems;
  }

  private static filterItems<T>(item: T, searchFields: (keyof T)[], terms: string[]): boolean {
    const normalizedFields = searchFields.map((searchField) =>
      SearchStringUtil.normalize(String(item[searchField])),
    );

    const hasMatch = normalizedFields.some((field) => {
      const fieldHasEveryTerm = terms.every((term) => field.includes(term));
      return fieldHasEveryTerm;
    });

    return hasMatch;
  }

  static sortByField<T>(items: T[], orderBy: keyof T): T[] {
    return items.sort((a, b) => {
      const A = String(a[orderBy]);
      const B = String(b[orderBy]);
      return A.localeCompare(B);
    });
  }
}
